import { memo } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { cn } from '@/lib/utils';
import { BoardCard } from '@/components/leads/board/BoardCard';
import type { IBoardColumnProps } from '@/@types/leadsBoard';

export const BoardColumn = memo(function BoardColumn({ stage, leads }: IBoardColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id: stage.status });
  const headingId = `board-column-heading-${stage.status}`;

  return (
    <div className="flex flex-col w-72 shrink-0">
      <div className="flex items-center justify-between px-1 pb-3">
        <h2 id={headingId} className="text-sm font-semibold text-foreground">
          {stage.label}
        </h2>
        <span className="text-xs text-muted-foreground light:text-[#4B5563] bg-muted rounded-full px-2 py-0.5">
          {leads.length}
        </span>
      </div>

      <div
        ref={setNodeRef}
        role="group"
        aria-labelledby={headingId}
        className={cn(
          'flex-1 min-h-[200px] rounded-xl border border-dashed border-border/60',
          'bg-background-secondary/40 p-2 space-y-2 transition-colors',
          isOver &&
            'border-solid border-2 border-primary light:border-primary-foreground bg-primary/10 light:bg-primary-foreground/10'
        )}
      >
        {leads.map(lead => (
          <BoardCard key={lead._id} lead={lead} />
        ))}
        {leads.length === 0 && (
          <p className="text-xs text-muted-foreground text-center py-6">No leads</p>
        )}
      </div>
    </div>
  );
});
